import CookieConsent from "react-cookie-consent";
import React from "react";
import { Link } from "react-router-dom";

const CookieConsentBanner = () => {
  return (
    <>
      <CookieConsent
        style={{ background: "#131B37" }}
        buttonStyle={{
          background: "#ffff",
          fontSize: "16px",
          borderRadius: "6px",
          color: "#131B37",
        }}
        declineButtonStyle={{
          background: "#fff",
          color: "#131B37",
          borderRadius: "6px",
        }}
        buttonText="Autoriser les cookies"
        declineButtonText="Décliner"
        enableDeclineButton
        expires={365}
      >
        <span>
          Ce site utilise des cookies pour améliorer votre expérience.{" "}
          <Link to="/politique-de-confidentialite" className="underline underline-offset-1">
            En savoir plus
          </Link>
        </span>
      </CookieConsent>
    </>
  );
};

export default CookieConsentBanner;
